import type { DomainMapper } from '../types';

const gb: DomainMapper = {
  countryCode: 'gb',
  currency: 'GBP',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/GB-UKM.svg',
  languagePrimary: true,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-uk.xml',
  storyblokBasePath: 'uk',
  url: 'https://kahrs-stage.iveo.store/uk',
  algoliaIndex: 'b2b-uk-en-GB-products',
  algoliaIndexAutocomplete: 'b2b-uk-en-GB-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1161,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1161,
    algoliaIndex: 'b2b-uk-en-GB-products',
    algoliaIndexAutocomplete: 'b2b-uk-en-GB-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-uk.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1162,
    algoliaIndex: 'b2c-uk-en-GB-products',
    algoliaIndexAutocomplete: 'b2c-uk-en-GB-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-uk-b2c.xml',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech',
} as DomainMapper;

export default gb;
